import { combineReducers } from 'redux';
import languageReducer from './languageReducer';

export default combineReducers({
  i18n: languageReducer,
});
